import { ExternalWebhook } from '@paragon/contract-library';

import { UserService } from '../connections';

export async function getExternalWebhooks() {
  return UserService.get<readonly ExternalWebhook[]>('externalWebhooks');
}

export async function createExternalWebhook(
  data: Pick<ExternalWebhook, 'externalWebhookUrl' | 'userProvidedName' | 'secretToken'>,
) {
  return UserService.post<{ guid: string }>('externalWebhooks', { data });
}

export async function renameExternalWebhook(guid: string, userProvidedName: string | null) {
  return UserService.patch<ExternalWebhook>(`externalWebhooks/${guid}`, { data: { userProvidedName } });
}

export async function deleteExternalWebhook(guid: string) {
  return UserService.delete<void>(`externalWebhooks/${guid}`);
}
